import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import strings from 'utils/strings'
import { getLocalTime } from 'utils/utils'
import { HISTORY_DATE_FORMATE, CURRENT_URI } from 'constants/featureSnapshots'

import { Icon, Tooltip } from 'components/patterns'
import { Paragraph } from 'components/patterns/Typography'

import {
  HistoryListItem,
  HistoryListItemCol,
  TimeStamp,
} from './FeatureHistoryCardContent.style'

const FeatureHistoryCardContent = ({ location, uri, user, date, selected }) => {
  const { pathname, search } = location

  const isCurrent = uri === CURRENT_URI

  return (
    <HistoryListItem>
      {date && (
        <HistoryListItemCol>
          <TimeStamp weight="bold">
            {date && getLocalTime(date, HISTORY_DATE_FORMATE)}
          </TimeStamp>
          <Paragraph size="small">{user}</Paragraph>
        </HistoryListItemCol>
      )}
      <HistoryListItemCol>
        <Paragraph size="small">
          {isCurrent && `(${strings.current_version})`}
        </Paragraph>
      </HistoryListItemCol>
      <HistoryListItemCol alignRight={selected}>
        {selected && (
          <Tooltip title={strings.open_in_new_window} placement="left">
            <Link to={{ pathname, search }} target="_blank">
              <Icon icon="new_window" size="small" />
            </Link>
          </Tooltip>
        )}
      </HistoryListItemCol>
    </HistoryListItem>
  )
}

FeatureHistoryCardContent.propTypes = {
  location: PropTypes.object,
  uri: PropTypes.string,
  user: PropTypes.string,
  date: PropTypes.string,
  selected: PropTypes.bool,
}

export default FeatureHistoryCardContent
